export class Coordinates{
    public lat: number;
    public lon: number;

}